module.exports = __webpack_public_path__ + "static/media/harnic.aa1ec3bc.svg";